import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import Link from 'next/link';
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'), {ssr: false});
import parse from 'html-react-parser';
import {CustomTabPanel} from '../TabTechnology';
import {AnimatedComponent} from '../AnimatedComponent';
import CommonCard from '../home/common-card';
import {CommonImageWrapper} from '../home/home-services';
import {fadeInUp} from '@/animation/scroll-animation';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import {borderRadius, fontWeight} from '@/styles/tokens';
import {ICON_TILE_ICON_SIZE} from '@/styles/iconTile';

const ServiceTab = (props: any) => {
    const {heading, subheading, technology, columns = 3} = props;
    const mdCols = Math.round(12 / columns) as 1 | 2 | 3 | 4 | 6 | 12;
    const [value, setValue] = React.useState(0);

    const renderCard = (serviceData: any) => {
        return (
            <>
                {serviceData.children?.map((item: any, index: number) => {
                    return (
                        <Grid item xs={12} sm={6} md={mdCols} lg={mdCols} key={index + 1}>
                            <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                <CommonCard>
                                    <CommonImageWrapper>
                                        <DisplayImage
                                            alt={item.heading}
                                            src={item.src}
                                            className="home-service-icon"
                                            width={ICON_TILE_ICON_SIZE}
                                            height={ICON_TILE_ICON_SIZE}
                                        />
                                    </CommonImageWrapper>
                                    {item.redirect ? (
                                        <Typography variant="h3" component="h3" mt={2} mb={2}>
                                            <Link target="_blank" href={item.redirect} className="card-redirection-heading font-headers ">
                                                {item.heading}
                                            </Link>
                                        </Typography>
                                    ) : (
                                        <Typography variant="h3" component="h3" mt={2} mb={2} className="font-headers">
                                            {item.heading}
                                        </Typography>
                                    )}

                                    <Typography variant="body1" className="font-regular-text" sx={{color: '#000'}}>
                                        {item.body ? parse(item.body) : ''}
                                    </Typography>
                                    <Box mt={1}>
                                        {item.content?.map((point: any, subIndex: any) => (
                                            <Box key={subIndex}>
                                                <Box display="flex" gap={1} mt={1}>
                                                    <Box mt={0.5}>
                                                        <CheckCircleOutlineOutlinedIcon fontSize="small" />
                                                    </Box>
                                                    <Typography className="font-regular-text" component="p">
                                                        {point ? parse(point) : ''}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </CommonCard>
                            </AnimatedComponent>
                        </Grid>
                    );
                })}
            </>
        );
    };

    return (
        <Box className="tab-technology-wrapper">
            <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                    {heading ? parse(heading) : ''}
                </Typography>
                <Typography variant="subtitle1" component="p" className="font-regular-text generative-transforming-subheading">
                    {subheading ? parse(subheading) : ''}
                </Typography>
            </Box>
            <Box>
                <Box>
                    <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap" mb={4}>
                        {technology?.map((item: any, index: number) => {
                            const isActive = value === index;
                            return (
                                <Box
                                    key={index + 1}
                                    onClick={() => setValue(index)}
                                    sx={{
                                        position: 'relative',
                                        px: '28px',
                                        pt: '22px',
                                        pb: isActive ? '18px' : '22px',
                                        borderRadius: borderRadius.xl,
                                        cursor: 'pointer',
                                        border: '2px solid #1f3f7a',
                                        fontWeight: fontWeight.bold,
                                        fontSize: '18px',
                                        lineHeight: '28px',
                                        letterSpacing: '-0.44px',
                                        transition: 'all 0.3s ease',
                                        bgcolor: isActive ? '#1f3f7a' : '#fff',
                                        color: isActive ? '#fff' : '#1f3f7a',
                                        boxShadow: isActive
                                            ? '0px 20px 25px 0px rgba(0,0,0,0.1), 0px 8px 10px 0px rgba(0,0,0,0.1)'
                                            : '0px 4px 6px 0px rgba(0,0,0,0.1), 0px 2px 4px 0px rgba(0,0,0,0.1)',
                                        whiteSpace: 'nowrap',
                                        '&:hover': {
                                            bgcolor: isActive ? '#1f3f7a' : '#f5f7fb'
                                        }
                                    }}
                                >
                                    {item.header}
                                    {isActive && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                bottom: '6px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: '56px',
                                                height: '4px',
                                                bgcolor: '#fff',
                                                borderRadius: '999px'
                                            }}
                                        />
                                    )}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
                {technology?.map((subData: any, index: number) => (
                    <CustomTabPanel value={value} index={index} key={index + 1}>
                        <Grid container spacing={3}>
                            {renderCard(subData)}
                        </Grid>
                    </CustomTabPanel>
                ))}
            </Box>
        </Box>
    );
};

export default memo(ServiceTab);
